import '@vitejs/plugin-react/preamble';
import React from 'react';
import ReactDOM from 'react-dom/client';
import InformativePage from './InformativePage';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <InformativePage />
  </React.StrictMode>
);
